import { connect } from 'react-redux';
import DashboardComercial from './dashboardComercial';

export default connect()(DashboardComercial);
